import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated: !!Cookies.get('tokenApi'),
  },
  reducers: {
    login: (state, action) => {
      Cookies.set('tokenApi', action.payload, { path: '/', secure: true, sameSite: 'Strict' });
      state.isAuthenticated = true;
    },
    logout: (state) => {
      Cookies.remove('tokenApi');
      state.isAuthenticated = false;
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
